import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class DataSourceSchemaUpdateModel extends ModeModelBase {
  override _name = 'dataSourceSchemaUpdate';
  override belongsTo = 'dataSource';
  override parentIdAttribute = 'token';
  override attributes = [{ name: 'token', default: '' }];
}

@Injectable({ providedIn: 'root' })
export class DataSourceSchemaUpdateModelAccessor extends ModelAccessorBase<DataSourceSchemaUpdateModel> {
  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.dataSourceSchemaUpdate');
  }
  override name = 'dataSourceSchemaUpdate';
  override parentModel = 'dataSource';
  override parentIdAttribute = 'token';
  createModel(resource, opts?) {
    const model = new DataSourceSchemaUpdateModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  }
}
